<template>
  <div class="page">

    <div class="search-bar">
      <searchbar @inputfinish="research" />
    </div>

    <div class="body flex">
      <div class="body-left">
        <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'guide'?'body-left-item-sel':''" data-type="guide" data-tit="读者指南" @click="textTypeSelect">
          <p class="font-size-14 font-bold">读者指南</p>
          <img v-if="textType == 'guide'" src="../../../assets/icon-lib-protocal-arrow.png" alt="">
        </div>
        <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'potocal'?'body-left-item-sel':''" data-type="potocal" data-tit="服务使用协议" @click="textTypeSelect">
          <p class="font-size-14 font-bold">服务使用协议</p>
          <img v-if="textType == 'potocal'" src="../../../assets/icon-lib-protocal-arrow.png" alt="">
        </div>
        <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'secret'?'body-left-item-sel':''" data-type="secret" data-tit="个人信息保护政策" @click="textTypeSelect">
          <p class="font-size-14 font-bold">个人信息保护政策</p>
          <img v-if="textType == 'secret'" src="../../../assets/icon-lib-protocal-arrow.png" alt="">
        </div>
        <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'feedback'?'body-left-item-sel':''" data-type="feedback" data-tit="咨询反馈" @click="textTypeSelect">
          <p class="font-size-14 font-bold">咨询反馈</p>
          <img v-if="textType == 'feedback'" src="../../../assets/icon-lib-protocal-arrow.png" alt="">
        </div>
        <div class="body-left-item flex-row-justify-space-between flex-row-align-center cursor" :class="textType == 'contact'?'body-left-item-sel':''" data-type="contact" data-tit="联系我们" @click="textTypeSelect">
          <p class="font-size-14 font-bold">联系我们</p>
          <img v-if="textType == 'contact'" src="../../../assets/icon-lib-protocal-arrow.png" alt="">
        </div>
      </div>
      <div class="body-right mach-width">
        <div class="body-right-tit flex-row-align-center">
          <p v-if="textType == 'guide'" class="font-size-30 font-bold">读者指南</p>
          <p v-if="textType == 'potocal'" class="font-size-30 font-bold">服务使用协议</p>
          <p v-if="textType == 'secret'" class="font-size-30 font-bold">个人信息保护政策</p>
          <p v-if="textType == 'feedback'" class="font-size-30 font-bold">咨询反馈</p>
          <p v-if="textType == 'contact'" class="font-size-30 font-bold">联系我们</p>
        </div>
        <div class="body-right-text ">
          <div v-if="textType=='secret'" class=" mach-width flex-column">
            <p class="tit">一、前言</p>
            <p class="desc">1. 欢迎使用“数字特藏服务平台”提供的服务！数字特藏服务平台（以下称“平台”或简称“我们”）深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息，我们亦将本《数字特藏服务平台隐私政策》（以下也称“本政策”）中的内容以高度审慎的义务对待和处理。</p>
            <p class="desc">2. 本政策与您所使用的我们的产品与或服务息息相关，您在下载、安装、启动、浏览、注册、登录、使用我们的产品与或服务（以下统称“使用我们的产品与或服务”或“使用产品与或服务”）时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，做出您认为适当的选择。本政策之中涉及的相关技术词汇，我们尽量以简明扼要的表述向您解释，以便于您理解。</p>
            <p class="desc">3. 您应当在仔细阅读、充分理解本政策后使用我们的产品或服务，如果您不同意本政策的内容，将可能导致我们的产品或服务无法正常运行，或者无法达到我们拟达到的服务效果，您应立即停止访问/使用我们的产品或服务。您使用或继续使用我们提供的产品或服务的行为，都表示您充分理解和同意本政策（包括更新版本）的全部内容。</p>
            <p class="desc">4. 如果您是未成年人，应在监护人陪同下阅读本政策，一旦使用本服务，视为您已获得您监护人的同意或指导。</p>
            <p class="desc">5. 我们已经以字体加粗或其他合理方式提示您重点阅读协议中与您的权益（可能）存在重大关系的条款，且双方同意其不属于《民法典》第 497 条规定的“免除其责任、加重对方责任、排除对方主要权利”的条款，即您和平台均认可该类条款的合法性及有效性，您不会以平台未尽到合理提示义务为由而声称协议中条款非法或无效。</p>
            <p class="desc">6. 如您在阅读本《数字特藏服务平台隐私政策》过程中有任何疑惑或其他相关事宜的，我们为您提供了多种反馈渠道，具体请见本政策“如何联系我们”章节，我们会尽快为您做出解答。</p>
            <p class="desc">7. 本政策适用于本平台，如与《数字特藏服务平台用户服务协议》、《数字特藏服务平台内容及审核规范》同类条款之约定存在不一致的，以本政策为准。如我们提供的某一单项服务不适用本政策的，该服务中会以适当方式明示排除适用本政策。</p>

            <p class="tit">二、我们如何收集和使用个人信息</p>
            <p class="desc">我们收集您的个人信息主要是为了您和其他用户能够更容易和更满意地使用平台。我们的目标是向所有的互联网用户提供安全、有趣及有教益的上网体验，而这些个人信息有助于我们实现这一目标。</p>
            <p class="desc">1、帮助您完成注册及登录</p>
            <p class="desc">为便于我们为您提供服务，您需要提供基本注册或登录信息，包括手机号码、读者证号码，并创建您的账号、用户名和密码。如果您仅需使用部分浏览、搜索、分享、查看资源内容服务，您不需要注册或登录及提供上述信息。</p>
            <p class="desc">在注册过程中，如果您提供以下额外信息，将有助于我们给您提供个性化的推荐和更优的服务体验：您的微信账号信息、昵称、性别、年龄、头像、所在地、就读院校。但如果您不提供这些信息，并不会影响您使用平台的基本功能。但是，依照相关法律法规的要求，您在使用特定功能及服务前，可能需要进行实名认证。为满足上述法律法规要求，我们将收集您的实名认证信息。如果您不提供实名认证信息，我们将不能向您提供相关的功能及服务。</p>
            <p class="desc">2、向您提供商品或服务</p>
            <p class="desc">（1）您向我们提供的个人信息：</p>
            <p class="desc">1) 您在使用平台时、上传、发布、审核、查阅资源以及进行相关行为（例如点赞、分享、收藏）时，我们将收集您上传、发布或形成的信息，并有权展示您的昵称、头像和发布内容。</p>
            <p class="desc">2) 在比赛、活动、申请捐赠证书等部分服务项目中，为便于向您交付奖品、证书或服务，您至少需向我们提供收货人个人身份信息、姓名、收货地址、邮政编码、收货人、联系电话、参与该服务的相关凭证及状态信息。同时，为积极完成服务项目，我们会将您的上述项目信息、物流信息等共享给相关的上述服务提供者。如果您拒绝提供此类信息，我们将无法完成相关交付服务。</p>
            <p class="desc">3) 当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式及相关个人信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
            <p class="desc">（2）我们在您使用服务过程中可能收集的个人信息：</p>
            <p class="desc">1) 为向您提供更契合您需求的页面展示和推荐个性化内容、进行用户画像、了解产品适配性、识别账号异常状态，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括</p>
            <p class="desc">2) 日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的登录账号、搜索查询内容、IP地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间及您访问的网页浏览记录、打开记录、停留时长、刷新记录、发布记录、关注、点赞、收藏及分享。</p>
            <p class="desc">3) 设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如IMEI、MAC、Serial、SIM卡IMSI识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、唯一设备标识符、软硬件特征信息）、设备所在位置相关信息（例如IP 地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器信息）。</p>
            <p class="desc">4) 请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
            <p class="desc">（3）我们通过间接方式收集到的您的个人信息：</p>
            <p class="desc">1) 我们可能从关联方、第三方合作伙伴获取您授权共享的相关个人信息。例如，我们可能从第三方获取您授权共享的账户信息（头像、昵称）并在您同意本隐私政策后将您的第三方账户与您的平台账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们将在符合相关法律法规规定，并依据与关联方或第三方合作伙伴的约定、确信其提供的个人信息来源合法的前提下，收集并使用您的这些个人信息。</p>
            <p class="desc">（4）基于上述您向我们提供的个人信息、我们可能收集的个人信息及我们通过间接方式收集到的您的个人信息，我们可能会基于上述一项或几项信息的结合，进行推荐算法建模、程序化广告推荐算法建模、用户行为分析及用户画像，以便向您提供更契合您需求的页面展示和推荐个性化内容。</p>
            <p class="desc">4、向您推送消息</p>
            <p class="desc">（1）我们可能使用您的个人信息（例如您的浏览及搜索记录、设备信息、位置信息、发布信息），用于提取您的浏览、搜索偏好、行为习惯、位置信息相关特征，并基于特征标签进行间接人群画像并通过电子邮件、系统消息、短信或其他方式向您发送营销信息，提供或推广平台服务或第三方商品和服务。</p>
            <p class="desc">（2）向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停某一单项服务、变更、终止提供某一单项服务时）向您发出与服务有关的通知。</p>
            <p class="desc">如您不希望继续接收我们推送的消息，您可要求我们停止发出通知，例如：根据短信退订指引要求我们停止发送通知短信；但我们依法律规定或单项服务的服务协议约定发送消息的 情形除外。</p>
            <p class="desc">5、为您提供安全保障</p>
            <p class="desc">为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或平台相关协议规则的情况。我们可能使用或整合我们所收集的您的个人信息，以及我们的合作伙伴取得您授权或依据法律共享的个人信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
            <p class="desc">6、改进我们的服务</p>
            <p class="desc">我们可能将通过某一项平台所收集的个人信息，用于我们的其他服务。例如，在您使用某一项平台功能和/或服务时所收集的您的个人信息，可能在另一项平台功能和/或服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息；我们可能让您参与有关平台的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的个人信息用于软件更新。</p>
            <p class="desc">您了解并同意，在收集您的个人信息后，如果我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们有权使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。</p>
            <p class="desc">7、其他用途</p>
            <p class="desc">请您注意，如果我们要将您的个人信息用于本政策中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您自主同意。一旦您同意，该等额外用途将视为本政策的一部分，该等额外个人信息也将适用本政策。</p>
            <p class="desc">8、征得授权同意的例外</p>
            <p class="desc">根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
            <p class="desc">（1）与国家安全、国防安全有关的；</p>
            <p class="desc">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
            <p class="desc">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
            <p class="desc">（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
            <p class="desc">（5）所收集的信息是您自行向社会公众公开的；</p>
            <p class="desc">（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</p>
            <p class="desc">（7）根据您的要求签订合同所必需的；</p>
            <p class="desc">（8）用于维护平台的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
            <p class="desc">（9）为合法的新闻报道所必需的；</p>
            <p class="desc">（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
            <p class="desc">（11）法律法规规定的其他情形。</p>
            <p class="desc">9、您理解并同意，我们可能需要您在您的设备中开启特定的访问权限（例如您的位置信息、摄像头、相册），以实现这些权限所涉及信息的收集和使用。当您需要关闭该功能时，大多数移动设备都会支持您的这项需求，具体方法请参考或联系您移动设备的服务商或生产商。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
            <p class="desc">10、个人敏感信息</p>
            <p class="desc">以上由您提供或我们收集您的个人信息中，可能包含您的个人敏感信息，例如银行账号、交易和消费记录、虚拟财产信息、系统账号、邮箱地址及其有关的密码、电话号码、网页浏览记录、位置信息。请您谨慎并留意个人敏感信息，您同意您的个人敏感信息我们可以按本隐私政策所述的目的和方式来处理。</p>

            <p class="tit">三、我们如何使用COOKIES或同类技术</p>
            <p class="desc">我们或我们的第三方合作伙伴可能通过COOKIES或同类技术获取和使用您的个人信息，并将该等信息储存为日志信息。</p>
            <p class="desc">通过使用COOKIES，我们向用户提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。我们使用COOKIES是为了让其用户可以受益。比如，为使得平台的登录/启动过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录平台的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在平台上花费的时间和您所选择的平台功能和/或服务。</p>
            <p class="desc">COOKIES使得我们能更好、更快地为您服务，并且使您在平台上的经历更富个性化。然而，您应该能够控制COOKIES是否以及怎样被你的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</p>
            <p class="desc">我们和第三方合作伙伴可能通过COOKIES或同类技术收集和使用您的个人信息，并将该等信息储存。</p>
            <p class="desc">我们使用自己的COOKIES或同类技术，可能用于以下用途：</p>
            <p class="desc">（1）记住您的身份。例如：COOKIES或同类技术有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</p>
            <p class="desc">（2）分析您使用我们服务的情况。我们可利用COOKIES或同类技术来了解您使用平台进行什么活动或哪些服务或服务最受欢迎；</p>
            <p class="desc">（3）消息推送优化。COOKIES或同类技术有助于我们根据您的个人信息，向您提供与您相关的活动、通知等消息信息而非进行普遍的发送。</p>
            <p class="desc">我们为上述目的使用COOKIES或同类技术的同时，可能将通过COOKIES或同类技术收集的非个人身份信息汇总提供给图书馆和其他伙伴，用于分析您和其他用户如何使用平台并用于消息推送及读者服务。</p>
            <p class="desc">平台上可能会有图书馆和其他合作方放置的COOKIES或同类技术。这些COOKIES或同类技术可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的内容，或用于评估用户服务的效果。</p>
            <p class="desc">您可以通过浏览器或用户选择机制拒绝或管理COOKIES。但请您注意，如果您停用COOKIES，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。同时，您仍然将收到推送消息，只是这些消息内容与您的相关性会降低。</p>

            <p class="tit">四、我们可能分享、转让或披露的个人信息</p>
            <p class="desc">（一）分享</p>
            <p class="desc">除以下情形外，未经您同意，我们不会与我们之外的任何第三方分享您的个人信息：</p>
            <p class="desc">1、向您提供我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以实现您需要的核心功能或提供您需要的服务；</p>
            <p class="desc">2、维护和改善我们的服务。我们可能向合作伙伴及其他第三方分享您的个人信息，以帮助我们为您提供更有针对性、更完善的服务，例如：代表我们发出电子邮件或推送通知的通讯服务提供商；</p>
            <p class="desc">3、实现本政策第一条“我们如何收集和使用个人信息”部分所述目的；</p>
            <p class="desc">4、履行我们在本政策或我们与您达成的其他协议中的义务和行使我们的权利；</p>
            <p class="desc">5、向图书馆、资源合作方、合作伙伴等第三方共享，目的是为了使其了解推广的覆盖面和有效性。比如我们可以告知其有多少人看了他们发布的资源和信息或在看到这些信息后进行了怎样的操作，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或读者；</p>
            <p class="desc">6、在法律法规允许的范围内，为了遵守法律、维护我们及我们的关联方或合作伙伴、您或其他平台用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，我们可能与其他公司和组织交换信息。不过，这并不包括违反本政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息；</p>
            <p class="desc">7、应您合法需求，协助处理您与他人的纠纷或争议；</p>
            <p class="desc">8、应您的监护人合法要求而提供您的个人信息；</p>
            <p class="desc">9、根据与您签署的服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；</p>
            <p class="desc">10、基于学术研究而提供；</p>
            <p class="desc">11、基于符合法律法规的社会公共利益而提供。</p>
            <p class="desc">我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息。对我们与之共享信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理信息。</p>
            <p class="desc">（二）转让</p>
            <p class="desc">1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</p>
            <p class="desc">2、在获得您的明确同意后，我们会向其他方转让您的个人信息。</p>
            <p class="desc">（三）披露</p>
            <p class="desc">我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的个人信息：</p>
            <p class="desc">1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</p>
            <p class="desc">2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</p>
            <p class="desc">（四）共享、转让、披露信息时事先征得授权同意的例外</p>
            <p class="desc">以下情形中，共享、转让、披露您的个人信息无需事先征得您的授权同意：</p>
            <p class="desc">1、与国家安全、国防安全有关的；</p>
            <p class="desc">2、与公共安全、公共卫生、重大公共利益有关的；</p>
            <p class="desc">3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
            <p class="desc">4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p class="desc">5、您自行向社会公众公开的信息；</p>
            <p class="desc">6、从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道。</p>
            <p class="desc">根据法律规定，共享、转让经去标识化处理的信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</p>

            <p class="tit">五、我们如何保留、储存个人信息</p>
            <p class="desc">我们仅在本政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息</p>
            <p class="desc">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
            <p class="desc">1、法律法规有明确规定；</p>
            <p class="desc">2、获得您的授权同意；</p>
            <p class="desc">3、您使用的产品、服务涉及跨境，我们需要向境外提供您的个人信息的。</p>
            <p class="desc">针对以上情形，我们会确保依据本政策及国家法律法规要求对您的个人信息提供足够的保护。</p>

            <p class="tit">六、我们如何保护个人信息安全</p>
            <p class="desc">我们非常重视个人信息安全，成立了专门的安全团队，并采取一切合理可行的措施，保护您的个人信息。</p>
            <p class="desc">1、数据安全技术措施</p>
            <p class="desc">我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）来保护您的个人信息，采取加密技术对您的个人信息进行加密保存，并通过隔离技术进行隔离。 在信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。</p>
            <p class="desc">2、我们为保护个人信息采取的其他安全措施</p>
            <p class="desc">我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。</p>
            <p class="desc">我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
            <p class="desc">加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
            <p class="desc">3、我们仅允许有必要知晓这些信息的平台员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与平台的合作关系。</p>
            <p class="desc">4、互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的个人信息安全。</p>
            <p class="desc">5、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
            <p class="desc">6、安全事件处置</p>
            <p class="desc">在通过平台与第三方进行沟通或授权服务时，请您妥善保护自己的信息，仅在必要的情形下向他人提供。</p>
            <p class="desc">为应对信息泄露、损毁和丢失等可能出现的风险，我们制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。我们也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。</p>
            <p class="desc">若不幸发生信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</p>
            <p class="desc">请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入平台所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
            <p class="desc">7、我们有行业先进的、以数据为核心的、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们会尽最大努力保障您的个人数据安全。</p>

            <p class="tit">七、如何管理个人信息</p>
            <p class="desc">（一）访问、更新和删除</p>
            <p class="desc">我们鼓励您更新和修改您的个人信息以使其更准确有效。您能通过平台访问您的个人信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段或提供提交申请的联系渠道，尽可能保证您可以访问、更新和更正自己的信息或使用平台时提供的其他信息。如您想查询、修改或删除您的部分个人信息，请登录平台进行相关操作，或者通过本隐私政策中载明的联系方式联系我们进行处理。</p>
            <p class="desc">在访问、更新、更正和删除前述个人信息时，我们可能会要求您进行身份验证，以保障信息安全。对于通过COOKIES或同类技术收集的您的个人信息，我们还在本政策第二条“我们如何使用COOKIES或同类技术”部分说明了向您提供的选择机制。</p>
            <p class="desc">（二）公开与分享</p>
            <p class="desc">我们的多项服务可让您不仅与您的社交网络、也与使用该服务的所有用户公开分享您的相关个人信息，例如，您在平台中所上传或发布的个人信息、您对其他人上传或发布的信息作出的回应，您在平台中不特定用户可见的公开区域内上传或公布您的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要您不删除您所公开或共享的信息，有关信息可能一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如您将信息通过上述渠道公开或共享，由此造成您的信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑是否通过上述渠道公开或共享您的个人信息。</p>
            <p class="desc">（三）改变您授权同意的范围</p>
            <p class="desc">您总是可以选择是否披露信息。有些信息是使用平台所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权。</p>
            <p class="desc">当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。</p>

            <p class="tit">八、第三方服务</p>
            <p class="desc">平台可能链接至第三方提供的资源平台、图书馆、读者服务或其他服务（包括网站或其他服务形式）。包括：</p>
            <p class="desc">（1）您可利用“分享”键将平台中的某些内容分享到第三方或将某些内容分享到平台。或者，您可利用第三方服务登录平台。这些功能可能会收集您的个人信息（包括您的日志信息），并可能在您的设备内装置COOKIES，从而正常运行上述功能；</p>
            <p class="desc">（2）我们通过推送消息或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站；</p>
            <p class="desc">（3）其他接入第三方服务的情形。</p>
            <p class="desc">例如，为实现本政策中声明的目的，我们可能会接入第三方SDK服务，并将我们依照本政策收集的您某些个人信息共享给该等第三方服务商，以便提高更好的客户服务和用户体验。</p>
            <p class="desc">目前，我们接入的第三方服务商主要包括以下几种类型：</p>
            <p class="desc">1、用于进行平台资源、展览比赛、活动信息的发布或推送</p>
            <p class="desc">2、用于进行平台内资源内容的审核</p>
            <p class="desc">3、用于便于您分享平台内容至第三方平台</p>
            <p class="desc">4、用于在您同意的情况下获取您的位置信息</p>
            <p class="desc">5、用于便于您使用第三方账户进行登录</p>
            <p class="desc">该等接入第三方服务由相关的第三方负责运营，须受第三方自己的服务条款及信息保护声明（而非本政策）约束。</p>
            <p class="desc">我们仅会出于正当、必要、特定的目的共享您的个人信息。对我们与之共享信息的第三方服务商，我们会要求他们履行相关保密义务并采取相应的安全措施。</p>

            <p class="tit">九、年龄限制</p>
            <p class="desc">我们建议任何未成年人参加网上活动应事先取得家长或其法定监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关个人信息。</p>
            <p class="desc">我们鼓励父母或监护人指导未成年人使用平台。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交个人信息之前寻求父母或监护人的同意和指导。</p>

            <p class="tit">十、通知和修订</p>
            <p class="desc">（一）我们可能适时修改本政策的条款，该等修改构成本政策的一部分。我们会在平台内，发出本政策的更新版本或以其他适当方式提醒您相关内容的更新。</p>
            <p class="desc">（二）我们可能在必需时（例如当我们由于系统维护而暂停某一项服务时）发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>

            <p class="tit">十一、如何联系我们</p>
            <p class="desc">如您有关于网络信息安全的投诉和举报，或您对本政策、您的个人信息的相关事宜有任何问题、意见或建议，以及有关本政策或平台的隐私措施的问题请与我们的协调人联系。地址是 market@bjadks.com 。</p>
            <p class="desc">一般情况下，我们将在收到您的问题、意见或建议之日起十五个工作日内予以回复。</p>
            <p class="desc text-right">《数字特藏服务平台》</p>
          </div>
          <div v-else-if="textType=='potocal'" class=" mach-width flex-column">
            <p class="tit">一、导言</p>
            <p class="desc">1. 在您注册、登录数字特藏服务平台以下（简称“本平台”）之前，应当仔细阅读并充分理解《数字特藏服务平台用户服务协议》（以下简称“本协议”）之全部条款，尤其是免除或者限制责任的条款、知识产权条款、法律适用及争议解决等。</p>
            <p class="desc">2. 本协议条款构成您使用本平台所提供的功能及服务之先决条件，您应当在仔细阅读、充分理解本协议后使用本平台；如果您对本协议的任何条款表示异议，或者无法准确理解本协议任何条款，请不要访问本平台。您使用本平台提供的功能与或服务的行为（分享、启动、浏览、注册、登录、使用等），都表示您同意本协议的全部条款，也意味您将接受本协议以及未来针对本协议更新版本的约束，并服从本平台的统一管理。</p>

            <p class="tit">二、服务协议的确认和变更</p>
            <p class="desc">1. 本协议是您（以下也称“用户”）与本平台之间关于登录、使用平台服务所订立的有约束力的法律文件。</p>
            <p class="desc">2. 本协议的内容包括协议正文、平台已发布或将来可能发布的其他声明、规则、公告，包括但不限于《数字特藏服务平台隐私政策》以及平台上出现的相关操作提示、答疑指南、使用帮助或本平台以其他方式向您展示的规则、流程等等。上述声明、规则、公告等均为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
            <p class="desc">3. 在您接受本协议之后，本协议可能因国家政策、产品或服务以及履行本协议的环境发生变化而进行不定期修改，修改后的协议发布在平台的适当位置，您可在平台内查阅本协议的最新版本。新协议一经公布即代替原协议。如您在本协议更新后继续使用平台的功能与/或服务，即表示您已充分阅读、理解并接受更新后的本协议并愿意受更新后的本协议约束。如您不接受更新后的协议，应立即停止使用平台提供的服务。</p>
            <p class="desc">4. 本协议所称“用户”，包括已登录绑定用户及未登录绑定的平台用户，须遵循除本协议用户注册规定以外的其他所有条款。</p>
            <p class="desc">5. 如您在阅读本协议过程中有任何疑惑或其他相关事宜的，本平台为您提供了问题反馈渠道，详见“联系方式”章节，平台会尽快为您做出解答。</p>

            <p class="tit">三、平台服务内容</p>
            <p class="desc">1. 本平台是一个为图书馆及个人用户提供内容服务的互联网平台，服务内容包括但不限于：各个图书馆的用户，以文字、图片、音频、视频、文档及压缩包等形式发布并捐献包含分享个人见解、记录生活内容、展示个人作品、传播知识、保存文化等类型的多媒体资源；图书馆可以收集、审核、整理、保存、使用、再传播本馆用户发布并捐献的多媒体资源；用户可以阅读、观看、收听、收藏、转发分享相关内容，从而实现用户为图书馆捐献馆藏，图书馆积极利用馆藏的传播、交流及互动。</p>
            <p class="desc">2. 本协议适用于本平台的所有产品与/或服务，包括但不限于软件、网站、服务以及包含的相关产品或服务功能，用户终端包括但不限于PC端、移动终端、本平台保管箱终端、物联网终端、朗读亭终端等。/启动过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录平台的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在平台上花费的时间和您所选择的平台功能和/或服务。</p>
            <p class="desc">3. 本平台的产品与/或服务，均仅限于用户在本平台的平台使用，任何以恶意破解等非法手段将本平台的产品与/或服务与本平台的平台分离的行为，均不属于本协议中约定的本平台的产品与服务。由此引起的一切法律后果由行为人负责，本平台将依法追究行为人的法律责任。</p>
            <p class="desc">4. 本平台官方公布的方式为下载、安装、启动、浏览、注册、登录、认证、使用本平台服务的唯一合法方式，用户通过其他任何未经过本平台合法授权的渠道、任何途径、任何方式获取的本平台的产品与服务（包括且不限于账号、发布、审核、查阅、浏览、客户端下载等服务）均为非法取得，本平台概不承认其效力，且一经发现本平台有权立即做出删除、取消、清零、封号等处理，任何因此导致的一切不利后果均由用户自行承担。</p>
            <p class="desc">5. 本平台有权提前向用户公告（包括但不限于弹出页面公告、本平台官方网站公告）以修改、替换、升级与本平台提供的任何产品与/或服务和/或上述产品与/或服务相关的任何软件。如果用户不同意本平台提供的任何产品与/或服务和/或上述产品与/或服务相关软件的修改、替换、升级，请直接拒绝、停止、取消，否则视为用户同意本平台提供的任何产品与/或服务和/或上述相关软件的修改、替代、升级，同时前述修改、替换、升级不影响本协议的效力。</p>

            <p class="tit">四、账号注册、登录与使用规则</p>
            <p class="desc">1. 用户在使用本服务前须进行账号登录。用户登录账号包括但不限于用户手机号登录、微信登录、读者账号/学号登录、校友身份登录。用户须按照平台要求提供真实、及时、准确的个人资料，包括但不限于手机号、身份信息、学籍信息及注册或更新注册信息时输入的所有信息（以下简称“个人资料”）。如个人资料有任何变动，用户须及时在本平台上予以更新。</p>
            <p class="desc">2. 用户在登录账号、填写个人资料时须承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在个人资料中出现违法和不良信息，不得冒用、关联机构或社会名人，且用户保证其在注册和使用账号时，特别不得有以下情形：</p>
            <p class="desc">（1) 违反宪法或法律法规规定的；</p>
            <p class="desc">（2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
            <p class="desc">（3) 损害国家荣誉和利益的，损害公共利益的；</p>
            <p class="desc">（4) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p class="desc">（5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p class="desc">（6) 散布谣言，扰乱社会秩序，破坏社会稳定的</p>
            <p class="desc">（7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
            <p class="desc">（8) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p class="desc">（9) 含有法律、行政法规禁止的其他内容的。</p>
            <p class="desc">3. 用户应当通过真实身份信息认证账号，且用户提交的名称、头像和简介等注册信息中不得出现违法和不良信息，平台有权对上述信息及用户的真实身份予以审查，若用户提供给平台的个人资料存在不准确、不真实、含有违法或不良信息的，平台有权不予注册并保留终止用户使用平台各项服务的权利。若用户以虚假信息骗取账号注册或账号头像、个人简介等个人资料存在违法和不良信息的，平台有权不经通知单方采取限期改正、清除、临时封停、永久封停、注销账号、收回等措施。对于冒用其它用户、注册登录账号的，平台有权注销该账号。同时，平台有权将上述行为移交有权部门处理。</p>
            <p class="desc">4. 用户不得通过任何手段恶意登录平台账号（包括但不限于使用无效未验证学号、邀请码、使用他人身份等恶意注册）或利用平台账号进行违法活动、捣乱、骚扰、 其他用户以及其他违反本协议的行为，平台有权对上述账号永久封停、注销登记、收回等措施，由此造成损失，由用户自行承担。同时，平台有权将上述行为移交有权部门处理。</p>
            <p class="desc">5. 平台用户账号所有权归本平台所有，用户仅拥有平台账号的有限使用权。平台用户账号仅限于用户本人使用，用户需对其享有使用权的账号下所从事的所有行为承担责任，用户应妥善保管自己的账号、学号、班级邀请码，禁止赠与、借用、租用、转让或售卖。如果平台发现使用者并非账号初始绑定人，有权不经通知收回账号而无需向账号使用人承担法律责任，由此带来的包括并不限于通讯中断、资料、已提交信息及资源清空等损失由用户自行承担。当用户的账号遭到未经授权的使用时，用户应当立即通知平台，否则未经授权的使用行为均视为用户本人的行为。</p>
            <p class="desc">6. 用户同意使用本服务期间，接受平台提供的商业信息，提供方式包括但不限于电子邮件、手机短信、系统消息等合法方式。对于上述平台发送的商业信息，用户有权取消订阅或者通过其他方式拒绝推送。</p>
            <p class="desc">7. 用户知悉并同意，平台提供的产品与服务需接入互联网方可使用，因此用户需自行承担使用产品与服务过程中所产生的上行和下行的网络通信及流量费用，上述费用将由网络运营商收取。用户亦可通过产品的设置页面对网络使用信息进行相关设置。</p>
            <p class="desc">8. 用户同意，发生争议时，与注册、登录、使用平台账号相关的一切数据和记录，包括但不限于所有登录、发布、审核、提交、使用、查阅、操作记录和相关的使用统计数字以本平台的系统数据为准。</p>

            <p class="tit">五、用户上传、编辑、分享等服务使用规则：</p>
            <p class="desc">1. 禁止用户利用平台提供的产品和服务从事以下行为：</p>
            <p class="desc">（1) 编辑、制作、上传、复制、传送、传播包含任何反对宪法所确定的基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、破坏民族团结、损害国家荣誉和利益、煽动民族仇恨、民族歧视、破坏民族团结、破坏国家宗教政策、宣扬邪教和封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪、侮辱或者诽谤他人，侵害他人合法权益的等法律、行政法规禁止的内容或其他另人反感的包括但不限于资讯、资料、文字、软件、音乐、视频、照片、图形、信息或其他资料；</p>
            <p class="desc">（2) 以任何方式危害未成年人；</p>
            <p class="desc">（3) 伪造标题或以其他方式操控识别资料，使人误认为该内容为本平台所传送；</p>
            <p class="desc">（4) 将无权传送的内容（例如内部资料、机密资料）进行上载、张贴、发送电子邮件、系统消息、手机短信息或以其他方式传送；</p>
            <p class="desc">（5) 将侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容加以上载、张贴、发送电子邮件、系统消息、手机短信息或以其他方式传送；</p>
            <p class="desc">（6) 将广告函件、促销资料、"垃圾邮件"等，加以上载、张贴、发送电子邮件、系统消息、手机短信息或以其他方式传送。供前述目的使用的专用区域除外；</p>
            <p class="desc">（7) 跟踪或以其他方式骚扰他人，非法侵入他人网络、干扰他人网络正常功能、窃取网络数据等危害网络安全的行为；</p>
            <p class="desc">（8) 向他人提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具，或明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助的行为；</p>
            <p class="desc">（9) 利用本平台提供的服务设立用于实施诈骗，传授犯罪方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，或利用本平台的网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息；</p>
            <p class="desc">（10) 干扰或破坏平台服务或与平台服务相连的服务器和网络；</p>
            <p class="desc">（12) 未经平台事先明确书面许可，以任何方式（包括但不限于机器人软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件）和任何理由自行或委托他人、协助他人获取平台的服务、内容、数据；</p>
            <p class="desc">（13) 未经平台事先明确授权，以商业性或其他非个人使用等目的为自己或他人获取、使用平台的资源与/或服务； 其他用户以及其他违反本协议的行为，平台有权对上述账号永久封停、注销登记、收回等措施，由此造成损失，由用户自行承担。同时，平台有权将上述行为移交有权部门处理。</p>
            <p class="desc">（14) 通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背平台提供服务/举办活动的初衷的方式）；</p>
            <p class="desc">（15) 通过侵犯本平台或他人合法权益的方式；</p>
            <p class="desc">（16) 其他未经平台明示授权许可或违反本协议、法律法规或监管政策的行为。</p>
            <p class="desc">2. 用户使用本平台功能与/或服务在平台制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的，应保证其上传内容不违反中国大陆地区及使用当地的法律法规及相关规范性文件，亦不侵犯任何第三方的合法权益，否则导致的一切不利后果均由用户自行承担，造成平台损失的，还应向平台承担赔偿责任。对于相关权利人因用户违反本款约定向平台主张权利的，平台有权不通知上传用户直接删除、下线、屏蔽相关争议内容。</p>

            <p class="desc">3. 用户对其利用平台服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的行为，独立完整地承担法律责任，包括如造成平台损失的，应向平台承担赔偿责任。同时：</p>
            <p class="desc">（1) 为了维护中国大陆地区及用户使用平台服务地区的法律法规及相关规范性文件、保护他人的合法权益、维护平台的信誉及安全，平台有权直接删除用户利用平台功能与/或服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容，而无需事先通知用户；</p>
            <p class="desc">（2)平台有权视情节严重程度对该用户做出封禁ID，暂时停止、永久禁止其利用平台功能与/或服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的处理；</p>
            <p class="desc">（3) 平台的后台记录有可能作为用户违反法律法规、违约、侵权的证据。</p>
            <p class="desc">4. 用户应当保证，不会利用本平台的功能或其衍生服务侵犯平台以及他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段破坏平台的正常经营，窃取、盗用他人的账号及账号下财产等；禁止侵犯他人合法权益的其他内容。否则，平台有权根据情节严重而对该用户及用户账号进行冻结、封号等处理。构成犯罪的，+平台有权移交有权部门处理。</p>

            <p class="tit">六、用户个人信息保护</p>
            <p class="desc">1. 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。您在启动、浏览、注册、登录、使用平台的功能与或服务时，本平台将按照已公布的《数字特藏服务平台隐私政策》的约定处理和保护您的个人信息，因此希望您能够仔细阅读、充分理解《数字特藏服务平台隐私政策》的全文，并在需要时，按照《数字特藏服务平台隐私政策》的指引，做出您认为适当的选择。</p>
            <p class="desc">2. 您应当在仔细阅读、充分理解《数字特藏服务平台隐私政策》后使用平台的功能或服务，如果您不同意政策的内容，将可能导致平台的功能或服务无法正常运行，或者无法达到平台拟达到的服务效果，您应立即停止访问/使用平台的功能与/或服务。您使用或继续使用平台提供的功能或服务的行为，都表示您充分理解和同意《数字特藏服务平台隐私政策》（包括更新版本）的全部内容。</p>
            <p class="desc">3. 平台深知个人信息对您的重要性，因此本平台非常重视保护您的隐私和个人信息，亦将您的个人信息以高度审慎的义务对待和处理。更多关于个人信息处理和保护规则、您对个人信息的控制权等内容，请您至本平台上查阅《数字特藏服务平台隐私政策》的全文。</p>

            <p class="tit">七、知识产权</p>
            <p class="desc">1. 受国际版权公约、中华人民共和国著作权法、专利法、反不正当竞争法及其他知识产权方面的法律法规的保护，本平台的功能或服务及所使用的软件、界面、交互等元素、LOGO、商标、标识、图形、文字、文本、声音、音频、视频、肖像、图片、技术、材料等的所有知识产权归平台所有和享有。“知识产权”包括在专利法、版权法、商标法、反不正当竞争法中等法律规定的任何和所有权利、任何和所有其它所有权以及其中的任何和所有应用、更新、扩展和恢复。</p>
            <p class="desc">2. 本服务中所涉及的平台图形、文字或其组成，以及其他平台标志及产品、服务名称，均为本平台标识。未经本平台事先书面同意，用户不得将本平台标识以任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理本平台标识的行为。用户由于非法使用本平台标识给本平台或他人造成损失的，由用户承担相关法律责任。</p>
            <p class="desc">3. 经由本平台传送的文字、图片、音频、视频及其他内容，受到著作权法、商标法、专利法或其他法律的保护；未经本平台书面授权许可，用户不得自行或许可第三方进行复制、下载、转载、传播、修改、售卖、衍生其他作品或者从事其他侵犯本平台知识产权的行为。用户在平台申请并获得授权使用的内容仅供用户自己依申请的相关约定合法使用，用户不得以任何形式，有偿或无偿使得第三方获得内容的全部或部分内容。</p>
            <p class="desc">4. 用户不得修改、改编、翻译平台服务所使用的软件、技术、材料等，或者创作与之相关的派生作品，不得通过反向工程、反编译、反汇编或其他类似行为获得其的源代码，否则由此引起的一切法律后果由用户负责，平台将依法追究违约方的法律责任。</p>
            <p class="desc">5. 用户只能在本协议以及平台明示授权的范围内容使用平台提供的功能或服务。未经平台事先书面许可，用户不得以任何营利性或非营利性的目的修改、复制、传播、传送、发行、转移、销售平台功能与/或服务所使用的软件、技术、材料以及产品/服务内容等或创造、制作与这些内容有关的派生产品或衍生品。否则，用户自行承担因此而造成对平台或其他人的全部损害。</p>
            <p class="desc">6. 未经平台事先书面同意，用户不得删除、掩盖或更改平台的版权声明、商标或其它权利声明/标签。本平台所有设计图样以及其他图样、功能及服务名称，均为平台所享有的商标、标识，未经本平台事先书面同意，任何人不得使用、复制或用作其他用途。用户不得对平台用于保护产品和服务的任何安全措施技术进行破解、更改、反操作、篡改或其他破坏。</p>
            <p class="desc">7. 经由平台功能或服务传送的内容，未经平台明示授权许可，用户不得进行修改、出租、散布、转载或衍生其他作品。平台对其自制内容和其他通过授权取得的独占内容享有完全知识产权，未经平台许可，任何单位和个人不得私自转载、传播和提供阅览及观看服务或者有其他侵犯平台知识产权的行为。否则，平台将追究侵权行为人的法律责任。</p>
            <p class="desc">8. 用户在使用平台的功能或服务的过程中可能需要登录平台的网站、手机应用、小程序或下载软件，对于该软件/程序，平台仅授予用户可撤销的、有限的、不可转让及非排他性的许可。除非平台事先明确书面授权，否则用户仅可为非商业的访问/使用产品、服务的目的而使用软件和平台提供的产品、服务。</p>
            <p class="desc">9. 平台所有和享有的知识产权，不因用户的任何使用行为而发生权利转移。</p>

            <p class="tit">八、双方权利与义务</p>
            <p class="desc">1. 用户必须为自己账号下发生的一切行为负责。用户须保证在平台的所有行为，包括但不限于发布、传播相关内容符合法律法规、相关政策及平台不定时更新的声明、规则、公告，符合公序良俗等基本社会规范。</p>
            <p class="desc">2. 用户在使用平台的功能或服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，平台一旦合理地认为用户存在上述行为的，可以在任何时候，不经事先通知终止向该用户提供产品或服务。</p>
            <p class="desc">3. 用户承诺对其发布于平台的内容拥有或取得了所有必要的权利，包括但不限于：有权或被合法授权使用和/或可合法授权平台使用所有与发布内容有关的所有知识产权、商业秘密、肖像权、表演者权等权利。同时，用户保证其发布到平台上的内容不侵犯任何人的合法权益，包括但不限于名誉权、隐私权等。平台有权对用户发布的内容在任何时间节点进行审核，若平台认为用户发布的内容存在违法、侵权或其他不恰当的情况，平台有权不经用户事先同意即采取屏蔽、删除内容、暂停用户账号的使用、注销用户账号等措施。</p>
            <p class="desc">4. 用户承诺，不将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料，加以上载、张贴、发送电子邮件或以其他方式传送；不以技术方式攻击或破坏或改变平台的部分或全部、或干扰其运行；不以非法方式获取或使用平台的任何软件、代码或其他技术或商业信息；不对平台运行的任何程序进行反向工程、反向编译、反向汇编或改写。</p>
            <p class="desc">5. 用户在此免费地、永久性地、不可撤销地在全世界范围内授权平台在界面设计、推广等活动中（包括但不限于频道设计、对外宣传、产品介绍等）免费使用其姓名（包括但不限于笔名、网名及任何代表用户身份的文字符号）、肖像。</p>
            <p class="desc">6. 用户同意授予平台在全世界范围内免费地、永久性地、不可撤销地使用和转授权用户通过平台发布或用户使用平台功能过程中形成的信息及内容（包括但不限于文字、图片、音频、视频）等，平台可以通过包括但不限于使用、复制、发行、改编、汇编、传播、修改、转授权、摄制、翻译、创建衍生作品、出版、表演、放映等方式使用相关内容。</p>
            <p class="desc">7. 用户许可平台有权就任何主体侵犯上述信息及内容的侵权而单独提起诉讼或开展其他法律行动。</p>
            <p class="desc">8. 本平台有权视严重情况，对违反本协议的用户采取以下单项或多项措施进行处罚：</p>
            <p class="desc">（1) 暂停/终止提供全部或部分服务；</p>
            <p class="desc">（2) 删除违规内容；</p>
            <p class="desc">（3) 暂时/永久封禁账号；</p>
            <p class="desc">（4) 修改、删除、清空部分或全部发布资源内容；</p>
            <p class="desc">9. 若平台认为用户账号内的资源或资源来源异常，平台有权对账号进行暂时冻结并进行调查。如调查后判定存在来源异常情形，则平台有权将来源异常部分进行修改、删除、清空部分或全部，情节严重者将进行账号封禁；来源异常情形包含但不限于：非平台认可的渠道上传、发布、审核、查阅，利用系统BUG、漏洞或外挂以及其他非正当方式来源上传、发布、审核、预览等。</p>
            <p class="desc">10. 若平台认为用户账号内的服务使用、数据、操作异常，平台有权对账号进行暂时冻结并进行调查。如调查后判定存在异常情形，则平台有权将操作异常部分进行修改、恢复、删除、清空部分或全部，情节严重者将进行账号封禁；操作异常情形包含但不限于：非平台认可的渠道管理、编辑、删除、使用平台资源和/或平台服务，利用系统BUG、漏洞或外挂以及其他非正当方式删除、修改、查阅、复制、下载、盗用等。</p>
            <p class="desc">11. 用户违反本协议，导致第三方向本平台及其关联公司、合作公司提出索赔等要求的，用户同意承担全部法律责任，包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等，并同意赔偿因此给平台造成的损害。用户承担赔偿责任的方式包括但不限于根据平台的书面通知向其支付与损失等额的资金、以累计的虚拟财产抵偿相关损失等。</p>
            <p class="desc">12. 平台为您提供账号注销权，您可以通过联系平台的客服或通过其他平台公示的方式注销您的账号（但法律法规另有规定的或本协议另有约定的除外），一旦您注销账号，将无法使用平台提供的功能或服务且自动放弃已有的权益，因此请您谨慎操作。除法律法规另有规定外，注销账号之后，平台将停止为您提供平台所有的功能和服务，您曾通过该账号使用的功能与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理。</p>

            <p class="tit">九、责任限制</p>
            <p class="desc">1. 用户理解并同意，本平台的功能或服务是按照现有技术和条件所能达到的现状提供的，平台无法保证其所提供的功能或服务毫无瑕疵，平台不对提供的功能或服务（含技术和信息）做出任何明示或暗示的承诺或保证，包括但不限于质量、稳定、正确、及时、完整、连贯、安全等，但平台承诺将不断提升服务质量及服务水平，为用户提供更加优质的服务。"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关个人信息。</p>
            <p class="desc">2. 为了改善用户体验、保证产品、服务的安全性及产品功能的一致性，平台可能会对软件进行更新。您应将软件更新到最新版本，否则平台并不保证其一定能正常使用。</p>
            <p class="desc">3. 平台对如下事项不做担保（包括但不限于）：</p>
            <p class="desc">（1) 平台提供的网站、手机应用、微信小程序等软件虽然均已经过测试，但由于技术本身的局限性，平台不能保证其与其他软硬件、系统完全兼容。如果出现不兼容的情况，用户可将情况报告平台，以获得技术支持。如果无法解决问题，用户可以选择卸载、停止使用平台的功能或服务；</p>
            <p class="desc">（2) 使用平台服务涉及到Internet服务，可能会受到各个环节不稳定因素的影响。因不可抗力、黑客攻击、系统不稳定、网络中断、用户关机、通信线路等原因，均可能造成平台的功能或服务中断或不能满足用户要求的情况。平台不保证功能或服务适合用户的使用要求；</p>
            <p class="desc">（3)本平台不做出任何与平台的功能或服务的安全性、可靠性、及时性和性能有关的担保；</p>
            <p class="desc">（4) 平台不保证其提供的任何产品、服务或其他材料符合用户的期望。 market@bjadks.com 。</p>
            <p class="desc">4. 基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，平台不承担任何直接、间接、附带、衍生或惩罚性的赔偿：</p>
            <p class="desc">（1) 平台的功能或服务使用或无法使用；</p>
            <p class="desc">（2) 经由平台的功能或服务购买或取得的任何产品、资料或服务；</p>
            <p class="desc">（3) 用户资料遭到未授权的使用或修改；</p>
            <p class="desc">（4) 其他与平台的产品或服务相关的事宜。</p>
            <p class="desc">6. 用户应妥善保管自己的账号和密码，加强密码安全性，谨防账号泄露或被盗。因用户账号被泄露或被盗而造成的任何损失，如账号、账号内财产等丢失、减少的，平台不承担补偿责任。用户因电信和网通部门的通讯线路故障、网络或电脑故障、系统不稳定、不可抗力（如服务器当机）等非平台原因造成账号、账号内财产等丢失、减少的，平台不承担补偿等责任。</p>
            <p class="desc">7. 用户因缺少身份认证或认证信息不真实而导致账号、账号内财产等丢失、减少而无法找回的，平台不承担任何法律责任。</p>
            <p class="desc">8. 用户理解并同意自主选择免费使用平台的功能或服务，风险自负，包括但不限于用户使用平台的功能或服务过程中的行为，以及因使用平台的功能或服务产生的一切后果。</p>
            <p class="desc">9. 用户知悉并同意，平台为了整体运营的需要，或自行决定进行业务变更、调整及技术变更等，有权随时修改或中断、中止或终止功能或服务而无需通知用户，也无需向用户或第三方负责或承担任何赔偿责任，除非法律另有规定或双方另有约定。</p>
            <p class="desc">10. 平台依据其自身判断，对于用户的任何违反或涉嫌违反中国法律或本协议约定的内容，有权视情节删除、屏蔽或断开链接；停止为用户提供服务或予以删除、撤销账户；并有权依据中国法律法规之规定保存有关信息并向相关政府部门进行报告。</p>
            <p class="desc">11. 平台仅承担本协议明确约定的直接责任。除本协议另有约定外，在任何情况下，平台对本协议所承担的赔偿责任总额不超过平台因向您提供功能或服务而收取的服务费总额。</p>
            <p class="desc">12. 不论是否可以预见，不论是源于何种形式的行为，平台不对由任何原因造成的特别的、间接的、惩罚性的、突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失、经营中断、资料灭失）承担责任。</p>

            <p class="tit">十、通知</p>
            <p class="desc">1. 本协议项下平台对于用户所有的通知均可通过网页公告、电子邮件、系统消息、手机短信或常规的信件传送等方式进行，该等通知于发送之日视为已送达用户。</p>

            <p class="tit">十一、特别声明</p>
            <p class="desc">1. 为免疑义，用户在此不可撤销地确认其知悉并同意平台内用户在本平台发布的内容只代表个人观点，并不反映或代表本平台的观点、立场或政策。平台有权审核、修改、自行删除且无需通知所有用户发布的内容，但对其合法性、准确性和完整性不作任何保证，对任何因此导致的直接的或间接的损失不承担任何责任。</p>
            <p class="desc">2. 用户因个人注册使用平台公告之系统停机维护、升级、调整，第三方原因如电信部门的通讯设备故障、计算机病毒或黑客攻击、技术问题、网络、电脑故障、系统不稳定性、台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制及其他各种不可抗力原因而遭受的一切损失，本平台及其合作单位不承担责任；平台对账号上所有服务将尽力维护其安全性及方便性，但对服务中出现的信息（包括但不限于用户发布的信息）删除或储存失败不承担任何责任。因技术故障等不可抗事件影响到服务的正常运行的，本平台及其合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，平台及其合作单位不承担责任。</p>
            <p class="desc">3. 用户充分理解并同意：因业务发展需要、突发情势等，平台能会变更，暂停、限制或者终止部分或全部服务，平台做出该等行为不需要事先进行通知。用户知悉并自愿承担该类风险及相关法律责任。</p>
            <p class="desc">4. 平台可能会提供第三方互联网网站或资源链接，除非另有声明外，平台无法对上述网站或资源链接进行控制，因此由于下载、传播、使用或依赖上述网站或资源所生的损失或损害，平台不承担任何责任。</p>

            <p class="tit">十二、联系方式</p>
            <p class="desc">1. 如您对本协议或使用平台的功能或服务相关的事宜有任何问题（包括问题咨询、投诉等），平台专门为您提供了多种反馈通道，希望为您提供满意的解决方案：</p>
            <p class="desc">（1) 在线客服/其他在线意见反馈通道：您可与平台上产品功能页面的在线客服联系或者在线提交意见反馈；</p>
            <p class="desc">（2) 人工客服通道：您可以拨打平台客服电话：400-8989-889与平台客户联系；</p>
            <p class="desc">（3) 专设的邮件通道：平台专门设立了 market@bjadks.com 邮箱，您可以通过该邮箱与平台联系；</p>
            <p class="desc">（4) 其他方式：平台提供的其他反馈通道。</p>
            <p class="desc">2. 平台会在收到您的反馈后尽快向您答复。</p>

            <p class="tit">十三、法律适用及争议解决</p>
            <p class="desc">1. 本协议适用中华人民共和国大陆地区施行的法律。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关协议将按法律规定进行修改或重新解释，而本协议其他部分的法律效力不变。</p>
            <p class="desc">2. 本协议的解释及争议解决均应适用中华人民共和国大陆地区法律。与本协议相关的任何纠纷，双方应协商友好解决；若不能协商解决，您同意将争议提交至北京市海淀区人民法院诉讼解决。双方同意，解决争议时，应以您同意的最新《数字特藏服务平台服务协议》为准。</p>
            <p class="desc text-right">《数字特藏服务平台》</p>
          </div>
          <div v-else-if="textType=='guide'" class=" mach-width flex-column">
            <p class="tit">一、多媒体资源管理系统定义</p>
            <p class="desc">多媒体资源管理系统（Multimedia Resources Management System），是指面向图书馆、博物馆、档案馆、艺术馆、党政事业单位、相关企业等机构用户开发的一款集采集、审核、加工、描述、保存、发布、展示等功能为一体的多媒体资源（图片、音频、视频、文档、压缩文件等格式）的管理系统。</p>
            <p class="tit">二、注册、登录</p>
            <p class="desc">展示前台支持个人用户通过手机注册和登录。未注册的手机号首次使用短信验证码自动登录后，即代表同意《服务使用协议》和《个人信息保护政策》中的相关内容，并完成账号注册。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-01.png" alt="">
              <p class="desc">个人登录界面</p>
            </div>
            <p class="desc">展示前台支持个人用户使用微信账号注册和登录。使用微信账号登录后需要绑定个人手机号。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-02.png" alt="">
              <img src="../../../assets/guide-03.png" alt="">
              <p class="desc">微信账号注册和登录</p>
            </div>
            <p class="desc">展示前台支持团体用户通过手机登录，未被管理员注册为团体用户的手机号将无法登录。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-04.png" alt="">
              <p class="desc">团体用户登录界面</p>
            </div>
            <p class="tit">三、认证</p>
            <p class="desc">展示前台提供面向个人用户的读者账密认证和校友身份认证两种模式。读者账密认证将对接机构读者认证系统，对读者身份进行核实校验；校友身份认证将对接机构校友身份信息记录，完成校友身份的核实校验。</p>
            <p class="desc">个人用户只能选择一种认证模式进行身份认证，完成身份认证后才允许创建馆藏。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-05.png" alt="">
              <p class="desc">读者账号认证界面</p>
              <img src="../../../assets/guide-06.png" alt="">
              <p class="desc">校友认证界面</p>
            </div>
            <p class="tit">四、创建馆藏</p>
            <p class="desc">团体用户和完成身份认证的个人用户，点击顶部菜单“创建”按钮，可上传图片、视频、音频、PDF文档、压缩包等类型的多媒体文件，单次上传文件限制50个以内，单个文件大小限制在5GB以内，文件类型与支持格式对应如下：</p>
            <div class="img flex-column-align-center mach-width">
              <table class=" mach-width" border="0" cellspacing="1" style="background: #000;text-align:left;">
                <tr>
                  <th class="font-size-16 font-bold bg-white">资源类型</th>
                  <th class="font-size-16 font-bold bg-white">限定文件格式</th>
                </tr>
                <tr>
                  <td class=" font-size-14 bg-white">图片</td>
                  <td class=" font-size-14 bg-white">PNG、JPG、JPEG、BMP、GIF、WEBP</td>
                </tr>
                <tr>
                  <td class=" font-size-14 bg-white">视频</td>
                  <td class=" font-size-14 bg-white">AVI、FLV、MP4、MPG、ASF、WMV、MOV、WMA、RMVB、RM</td>
                </tr>
                <tr>
                  <td class=" font-size-14 bg-white">音频</td>
                  <td class=" font-size-14 bg-white">MP3、WAV、AAC、WMA、OGG、M4A、AMR、AUDIO、M3U8</td>
                </tr>
                <tr>
                  <td class=" font-size-14 bg-white">文档</td>
                  <td class=" font-size-14 bg-white">PDF </td>
                </tr>
                <tr>
                  <td class=" font-size-14 bg-white">压缩包</td>
                  <td class=" font-size-14 bg-white">ZIP、RAR、7Z </td>
                </tr>
              </table>
              <p class="desc">资源类型与限定文件格式对照表</p>
            </div>

            <p class="desc">资源AI审核：资源上传完成后，手动点击下一步进行资源AI审核，进行资源涉黄、涉政、涉暴、涉及广告等审核。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-07.png" alt="">
              <p class="desc">资源AI审核界面</p>
            </div>
            <p class="desc">资源转码：资源AI审核完成后，会在界面中提示审核结果，未过审资源将被移入回收站中。资源AI审核完成后将自动跳转转码环节。根据多媒体文件的大小，转码时长约为5-100秒，用户可以选择在后台转码跳过该环节到馆藏著录界面。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-08.png" alt="">
              <p class="desc">资源转码界面</p>
            </div>
            <p class="desc">著录环节：包括馆藏著录和资源著录两部分。</p>
            <p class="desc">馆藏著录界面中可填写多媒体资源集合为一条馆藏实体的描述信息，包括：题名、副题名、目次、目次序列等标题元素；馆藏分类、学科、专题等分类元素；馆藏责任者、其他责任者、责任方式等作者元素；来源出版物、出版者、出版地、出版日期等来源元素；版权拥有者等版权元素；馆藏级别、典型年龄范围、馆藏信息等附属信息；馆藏封面、描述、关键词、纪事时间、纪事地点、纪事人物等内容元素。</p>
            <p class="desc">资源著录界面中可以填写多媒体资源作为独立资源实体的描述信息，包括：资源名称、资源描述、资源体裁、创作日期、纪事人物、内容语种、格式信息等元素。</p>
            <p class="desc">AI辅助著录：管理系统可以将用户填写的具有时间、地点、人物特征的关键词提取出来，供用户确认和手动选择：</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-09.png" alt="">
              <p class="desc">AI辅助馆藏著录</p>
              <img src="../../../assets/guide-10.png" alt="">
              <p class="desc">AI辅助资源著录</p>
            </div>
            <p class="desc">著录内容AI审核：著录环节完成后，手动点击下一步进行著录文字内容的AI审核，审核完成后单条采编环节完成：</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-11.png" alt="">
              <p class="desc">创建馆藏完成</p>
            </div>
            <p class="desc">创建馆藏完成后，用户可在页首菜单栏“我的”个人中心中查看馆藏审核与发布进展。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-12.png" alt="">
              <p class="desc">个人中心-我的上传</p>
            </div>
            <p class="tit">五、馆藏发现</p>
            <p class="desc">用户可通过首页搜索栏输入搜索词，搜索相关馆藏。首页搜索栏支持空检，不输入搜索词点击搜索按钮，将显示本机构全部可见馆藏。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-13.png" alt="">
              <p class="desc">首页搜索栏</p>
            </div>
            <p class="desc">用户可点击顶部菜单栏“数字特藏”按钮，将显示本机构全部可见馆藏。</p>
            <p class="desc">点击左侧筛选栏对馆藏进行筛选。左侧筛选栏包括：分类、学科、资源类型、专题、纪事地点、纪事人物、纪事年份、馆藏级别、发布人、发布日期、版权、权限范围等12个维度。</p>
            <p class="desc">馆藏可按照“最新发布”、“最早发布”、“纪事日期（最近）”、“纪事日期（最早）”、“浏览量”、“收藏量”等6种方式进行排序。</p>
            <p class="desc">馆藏可按照“缩略”和“列表”两种模式展示。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-14.png" alt="">
              <p class="desc">全部可见馆藏列表</p>
              <img src="../../../assets/guide-15.png" alt="">
              <p class="desc">排序方式</p>
              <img src="../../../assets/guide-16.png" alt="">
              <p class="desc">“缩略”模式</p>
              <img src="../../../assets/guide-17.png" alt="">
              <p class="desc">“列表”模式</p>
            </div>
            <p class="tit">六、资源发现</p>
            <p class="desc">用户可点击顶部菜单栏“数字特藏”按钮，将显示本机构全部可见馆藏。切换搜索栏左侧检索维度，可以检索并显示本机构全部可见资源。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-18.png" alt="">
              <p class="desc">切换检索维度</p>
            </div>
            <p class="desc">点击左侧筛选栏对资源进行筛选。左侧筛选栏包括：分类、学科、资源类型、专题、纪事人物、语种、时长、宽高比、创作日期、发布人、发布日期、版权、权限范围等13个维度。</p>
            <p class="desc">资源可按照“最新发布”、“最早发布”、“纪事日期（最近）”、“纪事日期（最早）”、“浏览量”、“收藏量”等6种方式进行排序。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-19.png" alt="">
              <p class="desc">全部可见资源列表</p>
              <img src="../../../assets/guide-20.png" alt="">
              <p class="desc">排序方式</p>
            </div>
            <p class="tit">七、用户发现</p>
            <p class="desc">用户可点击顶部菜单栏“数字特藏”按钮，将显示本机构全部可见馆藏。切换搜索栏左侧检索维度，可以检索并显示本机构全部用户。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-21.png" alt="">
              <p class="desc">切换检索维度</p>
            </div>
            <p class="desc">点击左侧类型筛选栏，可按用户类型对用户进行筛选。点击用户名称，可筛选该用户所创建的馆藏。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-22.png" alt="">
              <p class="desc">全部用户列表</p>
            </div>
            <p class="tit">八、馆藏详情</p>
            <p class="desc">点击馆藏链接，可进入馆藏详情页查看馆藏详情。馆藏详情包括：资源播放窗口部分，资源列表部分，馆藏著录信息区域，交互区域，相关馆藏展示区等五部分。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-23.png" alt="">
              <p class="desc">资源播放窗口-图片</p>
              <img src="../../../assets/guide-24.png" alt="">
              <p class="desc">资源播放窗口-音频</p>
              <img src="../../../assets/guide-25.png" alt="">
              <p class="desc">资源播放窗口-视频</p>
              <img src="../../../assets/guide-26.png" alt="">
              <p class="desc">资源播放窗口-PDF文档</p>
              <img src="../../../assets/guide-27.png" alt="">
              <p class="desc">资源列表展示区域</p>
              <img src="../../../assets/guide-28.png" alt="">
              <p class="desc">馆藏著录信息区域</p>
              <img src="../../../assets/guide-29.png" alt="">
              <p class="desc">交互区域</p>
              <img src="../../../assets/guide-30.png" alt="">
              <p class="desc">相关馆藏展示区</p>
            </div>
            <p class="tit">九、收藏与分享</p>
            <p class="desc">收藏：个人用户或者团体用户登录后，可在馆藏详情页-交互区域中点击“收藏”按钮，收藏该馆藏。收藏的馆藏将在页首菜单栏-个人中心中展示。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-31.png" alt="">
              <p class="desc">收藏/取消收藏按钮</p>
              <img src="../../../assets/guide-32.png" alt="">
              <p class="desc">个人中心-我的收藏</p>
            </div>
            <p class="desc">分享：用户可在馆藏详情页-交互区域中点击“分享”按钮，通过扫一扫二维码或者链接的方式分享到微信、QQ、微博等社交空间。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-33.png" alt="">
              <p class="desc">分享方式</p>
            </div>
            <p class="tit">十、举报与删除</p>
            <p class="desc">举报：个人用户或者团体用户登录后，可在馆藏详情页-交互区域中点击“举报”按钮，填写举报详情后可举报该馆藏。馆藏一经举报，将立即做冻结处理，无法访问。</p>
            <p class="desc">展示前台会将举报信息反馈到管理后台相关管理员处，等待管理员审核处理。恶意举报馆藏的用户可能面临被冻结或删除账号的风险。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-34.png" alt="">
              <p class="desc">填写举报详情</p>
            </div>
            <p class="desc">删除：个人用户或者团体用户登录后，可在个人中心-我的上传中点击“删除”按钮，并填写删除理由，申请删除已上传的馆藏。</p>
            <p class="desc">展示前台会将申请信息反馈到管理后台相关管理员处，等待管理员审核处理。审核通过后，展示前台将自动删除该馆藏。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-35.png" alt="">
              <p class="desc">填写删除理由</p>
            </div>
            <p class="tit">十一、首页信息展示</p>
            <p class="desc">首页信息展示区域包括：机构宣传视频区域，特色专题区域，数字特藏区域和宣传banner区域。</p>
            <p class="desc">机构宣传视频区域将循环播放本机构宣传视频。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-36.png" alt="">
              <p class="desc">机构宣传视频区域</p>
            </div>
            <p class="desc">特色专题区域将重点展示本机构专题事件，点击专题可跳转相关馆藏列表。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-37.png" alt="">
              <p class="desc">特色专题区域</p>
            </div>
            <p class="desc">数字特藏区域将重点展示本机构精品数字特藏，点击馆藏可跳转相关馆藏详情页。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-38.png" alt="">
              <p class="desc">数字特藏区域</p>
            </div>
            <p class="desc">宣传banner区域将重点展示本机构宣传专题事件，点击图片可跳转相关专题详情。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-39.png" alt="">
              <p class="desc">宣传banner区域</p>
            </div>
            <p class="tit">十二、账户管理</p>
            <p class="desc">个人用户、团体用户可点击页首菜单栏“我的”按钮进入个人中心。点击“设置”按钮进行账户管理。</p>
            <p class="desc">个人用户账户管理包括：个人资料，修改头像，学校信息，认证绑定等四部分。个人用户可修改和维护个人信息、学校信息，进行账号认账和绑定微信等。</p>
            <p class="desc">个人账户只能完成一次账号认定，绑定一个微信号。如需更换手机号码，可联系客服人员进行修改。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-40.png" alt="">
              <p class="desc">个人账户-账户管理</p>
            </div>
            <p class="desc">团体用户可在账户管理中查询和管理团体信息，包括：团体资料，修改头像等两部分。</p>
            <div class="img flex-column-align-center">
              <img src="../../../assets/guide-41.png" alt="">
              <p class="desc">团体账户-账户管理</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import searchbar from '@/components/Searchbar.vue'
import searchModel from '../../../models/search.js'

export default {
  name: 'Profile',
  components: {
    searchbar
  },
  data() {
    return {
      textType: '',
      textTit: ''
    }
  },
  created() {
    this.textType = this.$route.query.t || 'guide'
  },
  methods: {
    textTypeSelect(e) {
      const t = e.currentTarget.dataset.type
      if (t === 'feedback') {
        window.open('https://www.bjadks.com/Page/4-0-6.html', '_blank')
        // https://www.bjadks.com/Page/4-0-6.html
      } else if (t === 'contact') {
        window.open('https://www.bjadks.com/Page/4-30-6.html', '_blank')
      } else {
        this.textType = t
        this.textTit = e.currentTarget.dataset.tit
      }
    },
    research() {
      searchModel.viewData = { params: null, display: null, type: '' }
      this.$router.push({ name: 'Collection' })
    }
  }
}
</script>

<style src="@/styles/pc.css" scoped>
</style>
<style scoped>

.page {

  padding-top: 160px;
  padding-bottom: 100px;
}
 .page .body {
   width: 1240px;
   margin: 0 auto;
 }

 .body-left {
   width: 280px;
   padding-top: 26px;
 }

  .body-right {
    margin-left: 40px;
 }

 .body-left-item {
   height: 50px;
   border: 1px solid #fff;
   background-color:#F3F4F9;
   padding-left: 20px;
   padding-right: 15px;
 }

 .body-left-item:first-child {
   border: none;
 }

 .body-left-item-sel {
   background-color: #264480;
 }

.body-left-item-sel p {
  color: #fff;
}

.body-right-tit {
  border-bottom: 1px solid #F3F4F9;
  height: 84px;
 }

 .body-right-text .tit {
   color: #264480;
   font-size: 18px;
   margin: 40px 0;
   font-weight: bold;
 }

 .body-right-text .desc {
   font-size: 16px;
   margin-bottom: 20px;
   line-height: 26px;
 }

.body-right-text .text-right {
  text-align: right;
}

.img img {
  margin-bottom: 16px;
}

td,th {
  height: 40px;
  padding-left: 10px;

}

</style>
